export default __webpack_public_path__ + "static/media/Unify_Logo_Black.777513ff.svg";